<template>
  <div class="chart-container">
    <div
      class="chart-keys-container"
      :style="{
        justifyContent: isSingleBar ? 'center' : 'space-between'
      }"
    >
      <span v-for="(value, key) in chartData.labels" :key="key">{{ value }}</span>
    </div>
    <div class="chart-bars-container">
      <div
        v-for="(value, index) in chartData.values"
        :key="index"
        class="chart-bar"
        :style="{
          width: calculateBarWidth(value) + '%',
          height: isSingleBar ? '100px' : '20px',
          backgroundColor: hoveredIndex === index ? '#FF5733' : barColor
        }"
        @mouseover="showTooltip(index, value, $event)"
        @mouseleave="hideTooltip"
      ></div>

      <div
        v-for="unit in units"
        :key="unit"
        class="chart-line"
        :style="{ left: calculateUnitPosition(unit) + '%' }"
      ></div>
      <div v-if="tooltip.visible" class="chart-tooltip" :style="tooltipStyle">
        {{ tooltip.value }}
      </div>
      <div class="chart-units-container">
        <span v-for="unit in units" :key="unit" class="chart-unit" :style="{ left: calculateUnitPosition(unit) + '%' }">
          {{ unit }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    chartData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      maxValue: 0,
      barColor: '#FF7865',
      units: [],
      hoveredIndex: null,
      tooltip: {
        visible: false,
        value: '',
        x: 0,
        y: 0
      }
    };
  },
  computed: {
    tooltipStyle() {
      return {
        top: `${this.tooltip.y}px`,
        left: `${this.tooltip.x}px`
      };
    },

    isSingleBar() {
      return Object.keys(this.chartData.labels).length === 1;
    }
  },
  created() {
    this.calculateMaxValue();
    this.generateUnits();
  },
  watch: {
    chartData: {
      handler() {
        this.calculateMaxValue();
        this.generateUnits();
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    calculateMaxValue() {
      const values = Object.values(this.chartData.values).map(Number);
      const max = Math.max(...values);
      const maxValueInObject = Math.ceil(max / 100000) * 100000;
      this.maxValue = Math.ceil(maxValueInObject / 200000) * 200000;
    },
    generateUnits() {
      this.units = [];
      for (let i = 0; i <= this.maxValue; i += 200000) {
        this.units.push(i);
      }
    },
    calculateBarWidth(value) {
      return (Number(value) / this.maxValue) * 100;
    },
    calculateUnitPosition(unit) {
      return (unit / this.maxValue) * 100;
    },
    showTooltip(index, value, event) {
      this.hoveredIndex = index;
      this.tooltip.visible = true;
      this.tooltip.value = value;
      this.tooltip.x = event.clientX + 10;
      this.tooltip.y = event.clientY - 30;
    },
    hideTooltip() {
      this.hoveredIndex = null;
      this.tooltip.visible = false;
    }
  }
};
</script>

<style scoped>
.chart-container {
  width: 500px;
  display: flex;
  align-items: flex-start;
  margin: 20px 0;
}

.chart-keys-container {
  width: max-content;
  height: calc(100% - 30px);
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-right: 10px;
}

.chart-keys-container span {
  color: #333;
  font-weight: 500;
  font-size: 14px;
  margin: 6px 0 2px 0px;
}

.chart-bars-container {
  position: relative;
  flex: 1;
  padding-right: 5px;
}

.chart-bar {
  height: 20px;
  margin: 6px 0;
  background-color: #ff7865;
  cursor: pointer;
  transition: background-color 0.3s ease;
  transition: width 0.5s ease;
  z-index: 10;
  position: inherit;
}

.chart-tooltip {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
  pointer-events: none;
  z-index: 10;
  white-space: nowrap;
}

.chart-line {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 1px;
  background-color: #ddd;
  transform: translateX(-50%);
  z-index: 0;
}

.chart-units-container {
  position: relative;
  height: 20px;
  margin-top: 10px;
}

.chart-unit {
  position: absolute;
  bottom: -10px;
  transform: translateX(-50%);
  font-size: 10px;
  font-weight: 600;
  color: #777;
}
</style>
